<div class="p-4 md:p-6 w-full">
  <!-- Header -->
  <h1 class="text-2xl font-bold text-gray-800 flex items-center">
    <mat-icon style="color: #1c593d; margin-right: 8px"
      >currency_bitcoin</mat-icon
    >
    Transacciones Pendientes Cripto
    <span
      class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2"
    >
      {{ totalItems }} registros
    </span>
  </h1>
  <span
    class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mt-2"
  >
    {{ totalItems }} registros
  </span>

  <!-- Tabs -->
  <div class="flex gap-2 mt-4 border-b border-gray-200">
    <button
      type="button"
      (click)="onTabChange('CL')"
      [style.color]="activeTab === 'CL' ? '#1C593D' : '#6b7280'"
      [style.border-bottom]="activeTab === 'CL' ? '3px solid #1C593D' : '3px solid transparent'"
      style="
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 10px 16px;
        background: transparent;
        border: none;
        border-radius: 0;
        font-weight: 700;
        font-size: 0.9rem;
        cursor: pointer;
        transition: all 0.2s ease;
      "
    >
      <mat-icon style="font-size: 18px; width: 18px; height: 18px">public</mat-icon>
      Cripto Chile
    </button>
    <button
      type="button"
      (click)="onTabChange('VES')"
      [style.color]="activeTab === 'VES' ? '#1C593D' : '#6b7280'"
      [style.border-bottom]="activeTab === 'VES' ? '3px solid #1C593D' : '3px solid transparent'"
      style="
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 10px 16px;
        background: transparent;
        border: none;
        border-radius: 0;
        font-weight: 700;
        font-size: 0.9rem;
        cursor: pointer;
        transition: all 0.2s ease;
      "
    >
      <mat-icon style="font-size: 18px; width: 18px; height: 18px">account_balance_wallet</mat-icon>
      Cripto Venezuela
    </button>
  </div>

  <!--
    Solo lectura: qué redes no pueden usar hoy los clientes. Se encienden y
    apagan en Horario de Operaciones, junto al envío Binance.
  -->
  <div *ngIf="redesPausadas" role="status"
    class="mt-4"
    style="display: flex; align-items: flex-start; gap: 8px; padding: 10px 14px; background: #fffbeb; border: 1px solid #fde68a; border-left: 4px solid #f59e0b; border-radius: 10px;">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; flex-shrink: 0; color: #b45309;">pause_circle</mat-icon>
    <span style="font-size: 0.82rem; color: #92400e; line-height: 1.45;">
      Redes pausadas para los clientes: <strong>{{ redesPausadas }}</strong>.
      Se encienden y apagan en
      <a routerLink="/wallet/admin/hours-operations" style="color: #1C593D; font-weight: 700; text-decoration: underline;">Horario de Operaciones</a>.
    </span>
  </div>

  <!-- Filtros -->
  <div class="flex justify-center mt-6">
    <div
      class="w-full max-w-4xl bg-white p-6 rounded-xl shadow-lg border border-gray-100"
    >
      <div class="flex items-center gap-2 mb-4">
        <mat-icon
          style="color: #1c593d; font-size: 20px; width: 20px; height: 20px"
          >filter_list</mat-icon
        >
        <span class="text-sm font-semibold" style="color: #1e5a3f"
          >Filtros</span
        >
      </div>
      <div class="flex flex-col sm:flex-row items-center gap-3">
        <mat-form-field appearance="outline" class="modern-field flex-1 w-full">
          <mat-icon matPrefix style="color: #6b7280">search</mat-icon>
          <mat-label>Buscar transacción</mat-label>
          <input
            matInput
            type="text"
            placeholder="ID, remitente, beneficiario, wallet..."
            [(ngModel)]="filterValue"
            (ngModelChange)="applyFilter()"
          />
        </mat-form-field>
        <!-- Red del beneficiario (solo Chile): lo filtra el backend, así el paginador cuenta bien -->
        <mat-form-field *ngIf="!isVesTab" appearance="outline" class="modern-field w-full sm:w-60">
          <mat-icon matPrefix style="color: #6b7280">hub</mat-icon>
          <mat-label>Red</mat-label>
          <mat-select [value]="filtroRed" (selectionChange)="onFiltroRedChange($event.value)">
            <mat-option [value]="null">Todas las redes</mat-option>
            <mat-option *ngFor="let red of redesFiltro" [value]="red.id">
              {{ red.etiqueta }}{{ red.pagaBinance ? '' : ' · pago manual' }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!-- Solo lo que espera a un operador, en las dos pestañas: lo filtra el backend -->
        <mat-slide-toggle
          [checked]="soloPorProcesar"
          (change)="onSoloPorProcesarChange($event.checked)"
          color="primary"
          class="whitespace-nowrap">
          Solo por procesar
        </mat-slide-toggle>
        <button
          type="button"
          (click)="reload()"
          style="
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 10px 36px;
            background: #1c593d;
            color: white;
            border: none;
            border-radius: 10px;
            font-weight: 700;
            font-size: 0.9rem;
            cursor: pointer;
            transition: background 0.2s ease;
          "
          onmouseover="this.style.background = '#059669'"
          onmouseout="this.style.background = '#1C593D'"
        >
          <mat-icon
            style="font-size: 18px; width: 18px; height: 18px; color: white"
            >refresh</mat-icon
          >
          Refrescar
        </button>
      </div>
    </div>
  </div>

  <!-- Paginator -->
  <div class="flex justify-center mt-4">
    <mat-paginator
      #paginator
      class="demo-paginator"
      (page)="onPageChange($event)"
      [length]="totalItems"
      [pageSize]="pageSize"
      [disabled]="false"
      [showFirstLastButtons]="true"
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      [hidePageSize]="false"
      [pageIndex]="currentPage - 1"
      aria-label="Select page"
    >
    </mat-paginator>
  </div>

  <!-- ============ TABLA DESKTOP ============ -->
  <div
    class="hidden lg:block mt-4 overflow-x-auto rounded-xl shadow-lg border border-gray-100"
  >
    <table mat-table [dataSource]="transactionCripto" class="w-full">
      <!-- ID -->
      <ng-container matColumnDef="idTransferencia">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let row">
          <span
            class="font-mono font-bold bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs"
            [title]="row.idTransferencia"
          >
            {{ idDisplay(row) }}
          </span>
        </td>
      </ng-container>

      <!-- Fecha Inicio -->
      <ng-container matColumnDef="fechaInicio">
        <th mat-header-cell *matHeaderCellDef>F. Inicio</th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-xs"
          style="color: #374151"
        >
          {{ getDateFormatted(row.fechaInicio) }}
        </td>
      </ng-container>

      <!-- Fecha Fondo Wallet -->
      <ng-container matColumnDef="fechaFondoWallet">
        <th mat-header-cell *matHeaderCellDef>F. Fondo Wallet</th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-xs"
          style="color: #374151"
        >
          {{ getDateFormatted(row.fechaFondoWallet) }}
        </td>
      </ng-container>

      <!-- Fecha Termino -->
      <ng-container matColumnDef="fechaTermino">
        <th mat-header-cell *matHeaderCellDef>F. Término</th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-xs"
          style="color: #374151"
        >
          {{ getDateFormatted(row.fechaTermino) }}
        </td>
      </ng-container>

      <!-- Usuario -->
      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef>Usuario</th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-xs"
          style="color: #374151"
        >
          {{ $any(row).usuarioId }}
        </td>
      </ng-container>

      <!-- Remitente -->
      <ng-container matColumnDef="remitente">
        <th mat-header-cell *matHeaderCellDef>Remitente</th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-xs font-semibold"
          style="color: #374151"
        >
          {{ row.remitente }}
        </td>
      </ng-container>

      <!-- Beneficiario -->
      <ng-container matColumnDef="beneficiario">
        <th mat-header-cell *matHeaderCellDef>Beneficiario</th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-xs"
          style="color: #374151"
        >
          {{ row.beneficiario || "No aplica" }}
        </td>
      </ng-container>

      <!-- Tasa Negociación -->
      <ng-container matColumnDef="tn">
        <th mat-header-cell *matHeaderCellDef>T. Negociación</th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-xs font-bold"
          style="color: #7c3aed"
        >
          {{ row.tn | currency: "$" }}
        </td>
      </ng-container>

      <!-- Monto CLP / VES -->
      <ng-container matColumnDef="montoCLP">
        <th mat-header-cell *matHeaderCellDef>{{ montoOrigenLabel }}</th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-xs font-bold"
          style="color: #1e5a3f"
        >
          {{ row.montoCLP | currency: "$" }}
        </td>
      </ng-container>

      <!-- Monto USDT -->
      <ng-container matColumnDef="montoUSDT">
        <th mat-header-cell *matHeaderCellDef>Monto USDT</th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-xs font-bold"
          style="color: #1e5a3f"
        >
          {{ row.montoUSDT | currency: "$" }}
        </td>
      </ng-container>

      <!-- Wallet TRC20 / Wallet -->
      <ng-container matColumnDef="walletTRC20">
        <th mat-header-cell *matHeaderCellDef>{{ walletLabel }}</th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-xs font-mono"
          [title]="row.walletTRC20"
          style="
            color: #2563eb;
            max-width: 140px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          "
        >
          <span *ngIf="isVesTab && row.network" class="inline-block bg-gray-100 text-gray-700 px-1 py-0.5 rounded mr-1" style="font-size: 0.65rem; font-weight: 600">
            {{ row.network }}
          </span>
          <!-- Chile: red del beneficiario; las que no paga Binance resaltan porque se pagan a mano -->
          <span *ngIf="!isVesTab"
            class="inline-block px-1 py-0.5 rounded mr-1"
            [title]="esPagoManual(row) ? 'Pago manual: Binance no paga esta red' : 'La paga Binance'"
            [style.background]="esPagoManual(row) ? '#fef3c7' : '#f3f4f6'"
            [style.color]="esPagoManual(row) ? '#92400e' : '#374151'"
            [style.border]="esPagoManual(row) ? '1px solid #f59e0b' : '1px solid transparent'"
            style="font-size: 0.65rem; font-weight: 700">
            {{ etiquetaRedFila(row) }}{{ esPagoManual(row) ? ' · manual' : '' }}
          </span>
          {{ row.walletTRC20 }}
        </td>
      </ng-container>

      <!-- Estado -->
      <ng-container matColumnDef="estadoActual">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let row">
          <span
            class="px-2 py-1 inline-flex text-xs leading-5 font-bold rounded-full"
            [style.background]="getStatusBg(row)"
            [style.color]="getStatusColor(row)"
          >
            {{ row.estadoActual.replaceAll("_", " ") }}
          </span>
        </td>
      </ng-container>

      <!-- Acciones -->
      <ng-container matColumnDef="acciones" stickyEnd>
        <th mat-header-cell *matHeaderCellDef>Acciones</th>
        <td mat-cell *matCellDef="let row">
          <div
            style="
              display: flex;
              gap: 4px;
              justify-content: center;
              flex-wrap: wrap;
            "
          >
            <!-- Ver detalle (todas las filas) -->
            <button
              title="Ver detalle"
              (click)="verDetalle(row)"
              style="
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 30px;
                height: 30px;
                border: 1px solid #93c5fd;
                border-radius: 6px;
                background: #eff6ff;
                cursor: pointer;
              "
            >
              <mat-icon
                style="
                  font-size: 16px;
                  width: 16px;
                  height: 16px;
                  color: #2563eb;
                "
                >visibility</mat-icon
              >
            </button>
            <!-- Copiar -->
            <button
              title="Copiar"
              (click)="copy(row)"
              style="
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 30px;
                height: 30px;
                border: 1px solid #d1d5db;
                border-radius: 6px;
                background: white;
                cursor: pointer;
              "
            >
              <mat-icon
                style="
                  font-size: 16px;
                  width: 16px;
                  height: 16px;
                  color: #1c593d;
                "
                >content_copy</mat-icon
              >
            </button>
            <!-- Pagar / Confirmar (solo POR_PROCESAR) -->
            <button
              *ngIf="row.estadoActual === 'POR_PROCESAR'"
              [title]="isVesTab ? 'Aprobar (marcar pagado) o reenviar el retiro a Binance' : 'Marca la transacción como pagada'"
              (click)="isVesTab ? confirmVesWithdrawal(row) : openSendTransactionModal(row)"
              [disabled]="isLocked(row)"
              [style.opacity]="isLocked(row) ? '0.4' : '1'"
              [style.cursor]="isLocked(row) ? 'not-allowed' : 'pointer'"
              style="
                display: inline-flex;
                align-items: center;
                gap: 6px;
                height: 30px;
                padding: 0 12px;
                border: 1px solid #bbf7d0;
                border-radius: 6px;
                background: #f0fdf4;
                font-size: 12px;
                font-weight: 600;
                color: #15803d;
              "
            >
              <mat-icon style="font-size: 15px; width: 15px; height: 15px; color: #16a34a;">done</mat-icon>
              <span>{{ isVesTab ? 'Aprobar o reenviar' : 'Marcar como pagada' }}</span>
            </button>
            <!-- 30/10/2026: sin "Editar". Guardaba por el endpoint del cliente
                 (recipient/usdt/beneficiario-cripto), que rechaza al operador, y
                 el error no se mostraba. Queda pendiente una edición de wallets
                 propia del operador; EditCriptoTransactionComponent y
                 openEditModal() siguen en el código para eso. -->
            <!-- Rechazar (solo POR_PROCESAR) -->
            <button
              *ngIf="row.estadoActual === 'POR_PROCESAR'"
              title="Rechaza el retiro / la transacción"
              (click)="isVesTab ? rejectVesWithdrawal(row) : openRejectTransactionModal(row)"
              [disabled]="isLocked(row)"
              [style.opacity]="isLocked(row) ? '0.4' : '1'"
              [style.cursor]="isLocked(row) ? 'not-allowed' : 'pointer'"
              style="
                display: inline-flex;
                align-items: center;
                gap: 6px;
                height: 30px;
                padding: 0 12px;
                border: 1px solid #fecaca;
                border-radius: 6px;
                background: #fef2f2;
                font-size: 12px;
                font-weight: 600;
                color: #b91c1c;
              "
            >
              <mat-icon style="font-size: 15px; width: 15px; height: 15px; color: #dc2626;">close</mat-icon>
              <span>Rechazar</span>
            </button>
            <!-- Reenviar (solo Chile, solo POR_PROCESAR y solo TRC20: Binance no paga las demás redes) -->
            <button
              *ngIf="puedeReenviarABinance(row) && row.estadoActual === 'POR_PROCESAR'"
              title="Vuelve a enviar la transacción a Binance"
              (click)="resendTransaction(row)"
              [disabled]="isLocked(row)"
              [style.opacity]="isLocked(row) ? '0.4' : '1'"
              [style.cursor]="isLocked(row) ? 'not-allowed' : 'pointer'"
              style="
                display: inline-flex;
                align-items: center;
                gap: 6px;
                height: 30px;
                padding: 0 12px;
                border: 1px solid #fde68a;
                border-radius: 6px;
                background: #fefce8;
                font-size: 12px;
                font-weight: 600;
                color: #a16207;
              "
            >
              <mat-icon style="font-size: 15px; width: 15px; height: 15px; color: #ca8a04;">replay</mat-icon>
              <span>Reenviar a Binance</span>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <!-- ============ CARDS MOBILE ============ -->
  <div class="lg:hidden mt-4 space-y-3">
    <div
      *ngFor="let row of transactionCripto"
      class="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-200"
      [style.border]="
        expandedCardId === row.idTransferencia
          ? '2px solid #1C593D'
          : '1px solid #e5e7eb'
      "
    >
      <!-- Card Header (siempre visible) -->
      <div
        class="flex items-center justify-between p-3 cursor-pointer"
        (click)="toggleCard(row.idTransferencia)"
        [style.background]="
          expandedCardId === row.idTransferencia ? '#f0fdf4' : 'white'
        "
      >
        <div class="flex items-center gap-2 flex-1 min-w-0">
          <span
            class="font-mono font-bold bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs shrink-0"
            [title]="row.idTransferencia"
          >
            {{ idDisplay(row) }}
          </span>
          <span
            class="px-2 py-0.5 inline-flex text-xs leading-5 font-bold rounded-full shrink-0"
            [style.background]="getStatusBg(row)"
            [style.color]="getStatusColor(row)"
          >
            {{ row.estadoActual.replaceAll("_", " ") }}
          </span>
          <span *ngIf="esPagoManual(row)"
            class="px-1.5 py-0.5 rounded shrink-0"
            title="Pago manual: Binance no paga esta red"
            style="font-size: 0.62rem; font-weight: 700; background: #fef3c7; color: #92400e; border: 1px solid #f59e0b">
            {{ etiquetaRedFila(row) }}
          </span>
          <span class="text-xs font-semibold truncate" style="color: #374151">
            {{ row.remitente }}
          </span>
        </div>
        <div class="flex items-center gap-2 shrink-0">
          <span class="text-sm font-bold" style="color: #1e5a3f">
            {{ row.montoUSDT | currency: "$" }}
          </span>
          <mat-icon
            style="color: #6b7280; transition: transform 0.2s ease"
            [style.transform]="
              expandedCardId === row.idTransferencia
                ? 'rotate(180deg)'
                : 'rotate(0)'
            "
          >
            expand_more
          </mat-icon>
        </div>
      </div>

      <!-- Card Body (expandible) -->
      <div *ngIf="expandedCardId === row.idTransferencia" class="px-3 pb-3">
        <div class="grid grid-cols-2 gap-2 text-xs mb-3">
          <div>
            <span style="color: #6b7280; font-weight: 600">F. Inicio</span>
            <p style="color: #374151; font-weight: 500">
              {{ getDateFormatted(row.fechaInicio) }}
            </p>
          </div>
          <div>
            <span style="color: #6b7280; font-weight: 600"
              >F. Fondo Wallet</span
            >
            <p style="color: #374151; font-weight: 500">
              {{ getDateFormatted(row.fechaFondoWallet) }}
            </p>
          </div>
          <div>
            <span style="color: #6b7280; font-weight: 600">F. Término</span>
            <p style="color: #374151; font-weight: 500">
              {{ getDateFormatted(row.fechaTermino) }}
            </p>
          </div>
          <div>
            <span style="color: #6b7280; font-weight: 600">Usuario</span>
            <p style="color: #374151; font-weight: 500">
              {{ $any(row).usuarioId }}
            </p>
          </div>
          <div>
            <span style="color: #6b7280; font-weight: 600">Remitente</span>
            <p class="font-semibold" style="color: #374151">
              {{ row.remitente }}
            </p>
          </div>
          <div>
            <span style="color: #6b7280; font-weight: 600">Beneficiario</span>
            <p style="color: #374151; font-weight: 500">
              {{ row.beneficiario || "No aplica" }}
            </p>
          </div>
          <div>
            <span style="color: #6b7280; font-weight: 600">T. Negociación</span>
            <p class="font-bold" style="color: #7c3aed">
              {{ row.tn | currency: "$" }}
            </p>
          </div>
          <div>
            <span style="color: #6b7280; font-weight: 600">{{ montoOrigenLabel }}</span>
            <p class="font-bold" style="color: #1e5a3f">
              {{ row.montoCLP | currency: "$" }}
            </p>
          </div>
          <div class="col-span-2">
            <span style="color: #6b7280; font-weight: 600">Monto USDT</span>
            <p class="font-bold text-base" style="color: #1e5a3f">
              {{ row.montoUSDT | currency: "$" }}
            </p>
          </div>
          <div class="col-span-2">
            <span style="color: #6b7280; font-weight: 600">{{ walletLabel }}</span>
            <p class="font-mono text-xs break-all" style="color: #2563eb">
              <span *ngIf="isVesTab && row.network" class="inline-block bg-gray-100 text-gray-700 px-1 py-0.5 rounded mr-1" style="font-size: 0.65rem; font-weight: 600">
                {{ row.network }}
              </span>
              <span *ngIf="!isVesTab"
                class="inline-block px-1 py-0.5 rounded mr-1"
                [style.background]="esPagoManual(row) ? '#fef3c7' : '#f3f4f6'"
                [style.color]="esPagoManual(row) ? '#92400e' : '#374151'"
                style="font-size: 0.65rem; font-weight: 700">
                {{ etiquetaRedFila(row) }}{{ esPagoManual(row) ? ' · pago manual' : '' }}
              </span>
              {{ row.walletTRC20 }}
            </p>
          </div>
        </div>

        <!-- Acciones Mobile -->
        <div class="flex gap-2 pt-2 border-t border-gray-100">
          <button
            (click)="verDetalle(row); $event.stopPropagation()"
            class="flex-1"
            style="
              display: inline-flex;
              align-items: center;
              justify-content: center;
              gap: 4px;
              padding: 8px;
              border: 1px solid #93c5fd;
              border-radius: 8px;
              background: #eff6ff;
              cursor: pointer;
              font-size: 0.75rem;
              font-weight: 600;
              color: #2563eb;
            "
          >
            <mat-icon
              style="font-size: 14px; width: 14px; height: 14px; color: #2563eb"
              >visibility</mat-icon
            >
            Detalle
          </button>
          <button
            (click)="copy(row); $event.stopPropagation()"
            class="flex-1"
            style="
              display: inline-flex;
              align-items: center;
              justify-content: center;
              gap: 4px;
              padding: 8px;
              border: 1px solid #d1d5db;
              border-radius: 8px;
              background: white;
              cursor: pointer;
              font-size: 0.75rem;
              font-weight: 600;
              color: #1c593d;
            "
          >
            <mat-icon
              style="font-size: 14px; width: 14px; height: 14px; color: #1c593d"
              >content_copy</mat-icon
            >
            Copiar
          </button>
          <button
            *ngIf="row.estadoActual === 'POR_PROCESAR'"
            (click)="isVesTab ? confirmVesWithdrawal(row) : openSendTransactionModal(row); $event.stopPropagation()"
            class="flex-1"
            [disabled]="isLocked(row)"
            [style.opacity]="isLocked(row) ? '0.4' : '1'"
            [style.cursor]="isLocked(row) ? 'not-allowed' : 'pointer'"
            style="
              display: inline-flex;
              align-items: center;
              justify-content: center;
              gap: 4px;
              padding: 8px;
              border: 1px solid #bbf7d0;
              border-radius: 8px;
              background: #f0fdf4;
              font-size: 0.75rem;
              font-weight: 600;
              color: #16a34a;
            "
          >
            <mat-icon
              style="font-size: 14px; width: 14px; height: 14px; color: #16a34a"
              >done</mat-icon
            >
            {{ isVesTab ? 'Aprobar o reenviar' : 'Marcar como pagada' }}
          </button>
          <!-- 30/10/2026: sin "Editar", igual que en la tabla (pendiente la edición de wallets del operador). -->
          <button
            *ngIf="row.estadoActual === 'POR_PROCESAR'"
            (click)="isVesTab ? rejectVesWithdrawal(row) : openRejectTransactionModal(row); $event.stopPropagation()"
            class="flex-1"
            [disabled]="isLocked(row)"
            [style.opacity]="isLocked(row) ? '0.4' : '1'"
            [style.cursor]="isLocked(row) ? 'not-allowed' : 'pointer'"
            style="
              display: inline-flex;
              align-items: center;
              justify-content: center;
              gap: 4px;
              padding: 8px;
              border: 1px solid #fecaca;
              border-radius: 8px;
              background: #fef2f2;
              font-size: 0.75rem;
              font-weight: 600;
              color: #dc2626;
            "
          >
            <mat-icon
              style="font-size: 14px; width: 14px; height: 14px; color: #dc2626"
              >close</mat-icon
            >
            Rechazar
          </button>
          <button
            *ngIf="puedeReenviarABinance(row) && row.estadoActual === 'POR_PROCESAR'"
            (click)="resendTransaction(row); $event.stopPropagation()"
            class="flex-1"
            [disabled]="isLocked(row)"
            [style.opacity]="isLocked(row) ? '0.4' : '1'"
            [style.cursor]="isLocked(row) ? 'not-allowed' : 'pointer'"
            style="
              display: inline-flex;
              align-items: center;
              justify-content: center;
              gap: 4px;
              padding: 8px;
              border: 1px solid #fde68a;
              border-radius: 8px;
              background: #fefce8;
              font-size: 0.75rem;
              font-weight: 600;
              color: #ca8a04;
            "
          >
            <mat-icon
              style="font-size: 14px; width: 14px; height: 14px; color: #ca8a04"
              >replay</mat-icon
            >
            Reenviar a Binance
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
